import Cookies from 'js-cookie';

const CheckLoggedIn = () => {
  const token = Cookies.get('token');
  return !!token;
};

export default CheckLoggedIn;